<template>
  <div>
    <version-form />
  </div>
</template>

<script>
import VersionForm from '../components/version-form/VersionForm.vue'

export default {
  components: {
    VersionForm,
  },
}
</script>

 <style>

 </style>
